<form novalidate #motorsAcceptedPaymentsSectionForm="ngForm">
  <tg-row class="motors-accepted-payments__section">
    <tg-col sm="12" lg="4">
      <tg-checkbox-group label="Accepted payments" class="hide-optional-label">
        <tg-checkbox name="acceptedPayments_NZBank" (change)="onSelectionChange()"
          [(ngModel)]="draftData.listingDetails.acceptedPayments_NZBank"
          [disabled]="inputDisabled"
          >
          <tg-label> NZ bank deposit </tg-label>
        </tg-checkbox>

        <tg-checkbox name="acceptedPayments_Cash" (change)="onSelectionChange()"
          [(ngModel)]="draftData.listingDetails.acceptedPayments_Cash"
          [disabled]="inputDisabled">
          <tg-label> Cash </tg-label>
        </tg-checkbox>

        <tg-checkbox name="acceptedPayments_Other" (change)="onSelectionChange()"
          [(ngModel)]="draftData.listingDetails.acceptedPayments_Other"
          [disabled]="inputDisabled">
          <tg-label>Other (please specify)</tg-label>
          @if (draftData.listingDetails.acceptedPayments_Other) {
            <tg-input-container
              label="Other Payment Type" showLabel="false" hidden>
              <textarea tgTextInput name="payment-other-specified" type="text" type="text" rows="4"
                minLength="0" maxLength="70" (blur)="publish()"
                [(ngModel)]="draftData.listingDetails.otherPaymentDescription"
                [validation]="validation.listingDetails.otherPaymentDescription | toValidator"
                [disabled]="inputDisabled">
              </textarea>
            </tg-input-container>
          }
        </tg-checkbox>
      </tg-checkbox-group>
      @if (displayError) {
        <tg-row class="motors-accepted-payments__section-error">
          <tg-col>
            <p class="motors-accepted-payments__section__validate-fail">
              You need to select at least one accepted payment type
            </p>
          </tg-col>
        </tg-row>
      }
    </tg-col>
  </tg-row>
</form>